import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import RefreshIcon from '@material-ui/icons/Refresh';
import * as React from 'react';
import { TopToolbar, useRefresh, useTranslate } from 'react-admin';
import { ButtonFontWeightBoldStyles, TopToolbarButtonStyled, TopToolbarStyles } from '../../../theme';
import DynamicColumns from '../actions/dynamicColumns';
import SimpleActionMenu from './menuActions';
import ChangeView from './ChangeView';
import { IncidentListViewMode, KANBAN_LIST, SIMPLE_LIST } from '../../../utils/types';
import { useSelector } from 'react-redux';
import { CustomReducerState } from '../../../redux/reducers';
import DynamicOrderKanbanColumns from './dynamicOrderKanbanColumns';

const useStyles = makeStyles({
    // @ts-ignore
    topToolbar: {
        ...TopToolbarStyles,
    },
    buttonFontWeightBold: {
        ...ButtonFontWeightBoldStyles,
    },
    gridButtonOpenNewView: {
        // ...GridButtonShowViewStyles.gridButtonOpenNewView,
    },
    buttonOpenNewView: {
        // ...GridButtonShowViewStyles.buttonOpenNewView,
    },
});

const IncidentsListActions = ({ toggleColumn, enabledColumns }: any) => {
    const classes = useStyles();
    const translate = useTranslate();

    const refreshView: () => void = useRefresh();
    const viewMode: IncidentListViewMode = useSelector(
        (state: CustomReducerState) => state.ticketing.incidents.viewMode
    );

    return (
        <TopToolbar className={classes.topToolbar}>
            <Grid container spacing={2} alignItems={'center'}>
                <Grid item>
                    <SimpleActionMenu />
                </Grid>

                {/*<Grid item>*/}
                {/*    <ExportButton className={classes.buttonFontWeightBold} />*/}
                {/*</Grid>*/}

                <Grid item>
                    <TopToolbarButtonStyled
                        className={classes.buttonFontWeightBold}
                        startIcon={<RefreshIcon />}
                        onClick={refreshView}
                    >
                        {translate('app.menuActions.refresh')}
                    </TopToolbarButtonStyled>
                </Grid>

                {viewMode === SIMPLE_LIST ? (
                    <Grid item>
                        <DynamicColumns toggleColumn={toggleColumn} enabledColumns={enabledColumns} />
                    </Grid>
                ) : (
                    <span />
                )}

                {viewMode === KANBAN_LIST ? (
                    <Grid item>
                        <DynamicOrderKanbanColumns />
                    </Grid>
                ) : (
                    <span />
                )}

                <Grid item>
                    <ChangeView />
                </Grid>
            </Grid>
        </TopToolbar>
    );
};

export default IncidentsListActions;
